<template>
  <div>
    <ProgressBar active-step="About You" />
    <PageHeading
      v-if="routeId"
      :default-heading="pd_content.page_header.default"
      :edit-heading="pd_content.page_header.edit"
    />
    <form @submit.prevent>
      <div class="pvd-container container-divider">
        <h2 class="pvd-heading-XL">
          {{ pd_content.personal_information_section_header }}
        </h2>
        <ReadbackComponent
          :label="pd_content.name_label"
          :values="[`${pu_firstName} ${pu_lastName}`]"
          mask="true"
        />
        <ReadbackComponent
          :label="pd_content.dob_label"
          :values="[formattedDate]"
          mask="true"
        />
        <ToggleComponent
          :id-prefix="'usCitizen'"
          :toggle-value.sync="pu_usCitizen"
          :yes-label="pd_content.yes_toggle_text"
          :no-label="pd_content.no_toggle_text"
          :label="pd_content.citizenship_toggle_label"
          :track-events="true"
        />
        <div
          v-if="toggleCitizenshipDropdowns"
          id="citizenshipSection"
        >
          <DropdownComponent
            :dropdown-label="pd_content.citizenship_country_label"
            :dropdown-value.sync="pu_residenceCountry"
            :option-list="pd_countryList.validCitizenship"
            :id-prefix="'countryOfCitizenship'"
            :message="pd_content.citizenship_country_validation_text"
            :validation-rules="pd_content.citizenship_country_validation_rules"
            name="countryOfCitizenship"
          />
        </div>
        <div
          v-else
          id="ssnSection"
        >
          <InputSocialSecurity
            :id-postfix="'Ssn'"
            :css-class="'pvd-input input-ssn'"
            :type="'tel'"
            :label="pd_content.ssn_label"
            :value.sync="pu_ssn"
            :message="pd_content.ssn_validation_text"
            :validation-rules="pd_content.ssn_validation_rules"
            :autocomplete="'false'"
            name="inputSsn"
            mask="true"
          />
        </div>
      </div>
      <NavigationComponent />
    </form>
    <div
      v-if="showNbText"
      class="pvd-container"
    >
      <p class="xsmall color-neutral">
        {{ pd_content.site_footer_stock_plan_services_text }}
      </p>
    </div>
  </div>
</template>

<script>
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import ToggleComponent from '../components/ToggleComponent.vue';
import DropdownComponent from '../components/DropdownComponent.vue';
import ReadbackComponent from '../components/ReadbackComponent.vue';
import InputSocialSecurity from '../components/InputSocialSecurity.vue';
import utilityFunctions from '../mixins/utility';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import measurement from '../mixins/measurement';

export default {
  name: 'PersonalInformationIS',
  components: {
    ReadbackComponent,
    NavigationComponent,
    PageHeading,
    ProgressBar,
    ToggleComponent,
    DropdownComponent,
    InputSocialSecurity,
  },
  mixins: [dataHelper, dataSanitize, utilityFunctions, measurement],
  data() {
    return {
      initialState: {},
      backButtonAttempt: false,
    };
  },
  computed: {
    toggleCitizenshipDropdowns() {
      return this.pu_usCitizen === 'No';
    },
    formattedDate() {
      return this.formatTextualDate(this.pu_dob.toString());
    },
    showNbText() {
      return this.isNetBenefits();
    },
  },
  watch: {
    pu_usCitizen() {
      if (this.pu_usCitizen === 'Yes') {
        this.pu_residenceCountry = '999';
      } else if (this.pu_usCitizen === 'No' && this.pu_residenceCountry === '999') {
        this.pu_residenceCountry = '';
      }
    },
  },
  created() {
    this.unsubscribe = this.sanitizeData('primaryUser');
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    this.updatePageTitle();
    this.configureFirstPageBackButton(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
  updated() {
    this.updatePageTitle();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    updatePageTitle() {
      const pageHeader = this.pd_content.page_header;
      if (pageHeader) {
        let heading = this.cs_editMode
          ? pageHeader.edit : pageHeader.default;
        if (!pageHeader.edit) {
          heading = pageHeader.default;
        }
        if (heading) {
          document.title = this.setTitle(heading);
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>
